import CryptoJS from "crypto-js";
import { canonicalize } from "json-canonicalize";
import { hasOwn } from "../commonFunctions/arrayFunc";

const checksum = {
  initial: {
    checksum: "",
    config: ""
  },
  modified: {
    checksum: "",
    config: ""
  }
};

export const setInitialChecksum = (config) => {
  const newConfig = JSON.parse(JSON.stringify(config));
  checksum.initial.checksum = createChecksum(newConfig);
  checksum.initial.config = newConfig;
};

export const setModifiedChecksum = (config) => {
  const newConfig = JSON.parse(JSON.stringify(config));
  checksum.modified.checksum = createChecksum(newConfig);
  checksum.modified.config = newConfig;
};

export const setInitialAndModifiedChecksum = (config) => {
  setInitialChecksum(config);
  setModifiedChecksum(config);
};

export const hasChecksumChanged = () => {
  const canonicalJson1 = canonicalize(checksum.initial.config);
  const canonicalJson2 = canonicalize(checksum.modified.config);
  return canonicalJson1 !== canonicalJson2;
  // return checksum.initial.checksum !== checksum.modified.checksum;
};

export const getInitialChecksum = () => {
  return checksum.initial;
};

export const getModifiedChecksum = () => {
  return checksum.modified;
};

// const resetChecksums = () => {
//   checksum.initial = {
//     checksum: "",
//     config: ""
//   };
//   checksum.modified = {
//     checksum: "",
//     config: ""
//   };
// };

export const comparedChecksumConfig = () => {
  const initialConfig = checksum.initial.config;
  const modifiedConfig = checksum.modified.config;
  const diff = getObjectDifference(initialConfig, modifiedConfig);
  return diff;
};

// const comparedWithInitialChecksum = (config) => {
//   const initialConfig = checksum.initial.config;
//   const modifiedConfig = config;
//   const diff = getObjectDifference(initialConfig, modifiedConfig);
//   return diff;
// };

export const comparedWithModifiedChecksum = (config) => {
  const modifiedConfig = checksum.modified.config;
  const initialConfig = config;
  const diff = getObjectDifference(initialConfig, modifiedConfig);
  return diff;
};

export const hasChecksumChangedWithModified = (config) => {
  const canonicalJson1 = canonicalize(config);
  const canonicalJson2 = canonicalize(checksum.modified.config);
  return canonicalJson1 !== canonicalJson2;
};

export const createChecksum = (obj) => {
  const canonicalJson2 = canonicalize(obj);
  const jsonString = JSON.stringify(canonicalJson2, (key, value) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      // Sort object keys
      return Object.keys(value)
        .sort()
        .reduce((sorted, k) => {
          sorted[k] = value[k];
          return sorted;
        }, {});
    } else if (Array.isArray(value)) {
      // Sort array items
      // return value.slice().sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    }
    return value;
  });

  const hash = CryptoJS.SHA256(jsonString).toString();
  return hash;
};

export const getObjectDifference = (obj1, obj2) => {
  function diff(obj1, obj2) {
    const result = { updated: {}, deleted: {}, added: {} };

    if (obj1 && typeof obj1 === "object") {
      for (const key in obj1) {
        if (obj2 && hasOwn(obj2, key)) {
          if (obj1[key] === null && obj2[key] !== null) {
            result.updated[key] = { oldValue: obj1[key], newValue: obj2[key] };
          } else if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
            const arrayDiff = getArrayDifference(obj1[key], obj2[key]);
            if (arrayDiff.length > 0) {
              result.updated[key] = arrayDiff;
            }
          } else if (
            typeof obj1[key] === "object" &&
            obj1[key] !== null &&
            typeof obj2[key] === "object" &&
            obj2[key] !== null
          ) {
            const nestedDiff = diff(obj1[key], obj2[key]);
            if (Object.keys(nestedDiff.updated).length > 0) {
              result.updated[key] = nestedDiff.updated;
            }
            if (Object.keys(nestedDiff.deleted).length > 0) {
              result.deleted[key] = nestedDiff.deleted;
            }
            if (Object.keys(nestedDiff.added).length > 0) {
              result.added[key] = nestedDiff.added;
            }
          } else if (obj1[key] !== obj2[key]) {
            result.updated[key] = { oldValue: obj1[key], newValue: obj2[key] };
          }
        } else {
          result.deleted[key] = obj1[key];
        }
      }
    }

    if (obj2 && typeof obj2 === "object") {
      for (const key in obj2) {
        if (!obj1 || !hasOwn(obj1, key)) {
          result.added[key] = obj2[key];
        }
      }
    }

    return result;
  }

  return diff(obj1, obj2);
};

const getArrayDifference = (arr1, arr2) => {
  const maxLength = Math.max(arr1.length, arr2.length);
  const differences = [];

  for (let i = 0; i < maxLength; i++) {
    if (i < arr1.length && i < arr2.length) {
      if (
        typeof arr1[i] === "object" &&
        arr1[i] !== null &&
        typeof arr2[i] === "object" &&
        arr2[i] !== null &&
        !Array.isArray(arr1[i]) &&
        !Array.isArray(arr2[i])
      ) {
        const itemDiff = getObjectDifference(arr1[i], arr2[i]);
        if (
          Object.keys(itemDiff.updated).length > 0 ||
          Object.keys(itemDiff.deleted).length > 0 ||
          Object.keys(itemDiff.added).length > 0
        ) {
          differences.push({ index: i, ...itemDiff });
        }
      } else if (Array.isArray(arr1[i]) && Array.isArray(arr2[i])) {
        const nestedArrayDiff = getArrayDifference(arr1[i], arr2[i]);
        if (nestedArrayDiff.length > 0) {
          differences.push({ index: i, updated: nestedArrayDiff });
        }
      } else if (arr1[i] !== arr2[i]) {
        differences.push({ index: i, updated: { oldValue: arr1[i], newValue: arr2[i] } });
      }
    } else if (i < arr1.length) {
      differences.push({ index: i, deleted: arr1[i] });
    } else {
      differences.push({ index: i, added: arr2[i] });
    }
  }

  return differences;
};

// const isObjectEmpty = (obj) => {
//   return Object.keys(obj).length === 0 && obj.constructor === Object;
// };

// const isConfigUpdated = (actualConfig, comparedConfig) => {
//   const changedConfig = getObjectDifference(actualConfig, comparedConfig);

//   const { updated, deleted, added } = changedConfig;

//   if (isObjectEmpty(updated) && isObjectEmpty(deleted) && isObjectEmpty(added)) {
//     return {
//       is_updated: true,
//       changed_config: changedConfig
//     };
//   }
//   return {
//     is_updated: false,
//     changed_config: changedConfig
//   };
// };
